import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	height: -webkit-fill-available;
	padding: 1%;
	background-color: ${colors.grey1};
	overflow: clip scroll;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 1% 0 0 0;
	.ag-theme-balham {
		width: 100%;
		height: 68vh;

		@media (max-width: 1440px) {
			height: 68vh;
		}

		@media (max-width: 1366px) {
			height: 62vh;
		}

		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;

export const KpiGridContainer = styled.div`
	display: flex;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 100px 0;
`;
